export default __webpack_public_path__ + "static/media/metrics-card-template.97e0a34d.png";